var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c("theme-calendar", {
        ref: "picker",
        attrs: { label: _vm.label, name: _vm.name, value: _vm.date },
        on: { input: _vm.inputHandler }
      }),
      _vm._v(" "),
      this.date
        ? _c("div", { staticClass: "absolute top-[52%] right-4 z-10" }, [
            _c("span", { on: { click: _vm.prev } }, [
              _c("i", { staticClass: "icon-thin-left orange-icon py-2 px-3" })
            ]),
            _vm._v(" "),
            _c("span", { on: { click: _vm.next } }, [
              _c("i", { staticClass: "icon-thin-right orange-icon py-2 px-3" })
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d815e2c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d815e2c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeCalendarWithButtons.vue
// module id = 768
// module chunks = 1